module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [(!_vm.datas) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("加载中......")])]) : _vm._e(), _vm._v(" "), (_vm.datas && _vm.datas.length) ? _vm._l((_vm.datas), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "ushk-rili_content-time"
    }, [_vm._v(_vm._s(_vm._f("dateFormat")(data.date, 'yyyy-MM-dd')))]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(data.country) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.exchangename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.holidayname))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "ushk-table_alignLeft"
    }, [_vm._v(_vm._s(data.note))])])])
  }) : _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("今日无假期休市安排")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15486306","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/calendar/modules/HolidayList.vue
// module id = se+W
// module chunks = 3